import * as React from 'react';
import { ChildDataProps, graphql } from 'react-apollo';

import TopSectionComponent from '../../../components/HomePage/TopSection/TopSection';
import { TopSectionLocale } from '../../../components/HomePage/TopSection/topSection.locale';
import { Query, TrafficQueryArgs } from '../../../GraphQL';
import trafficQuery from './trafficQuery.gql';

interface OwnProps {
  locale: TopSectionLocale;
}

interface TopSectionProps extends ChildDataProps<OwnProps, Query, TrafficQueryArgs> {}

const TopSection: React.SFC<TopSectionProps> = ({ locale, data }) => (
  <TopSectionComponent
    locale={locale}
    traffic={
      data.traffic
        ? data.traffic.map(trafficPoint => ({
            ...trafficPoint,
            timestamp: trafficPoint.timestamp,
          }))
        : []
    }
  />
);

export default graphql<OwnProps, Query, TrafficQueryArgs, TopSectionProps>(trafficQuery, {
  options: ({ locale }) => {
    const cacheLifetime = 1000 * 60 * 5;
    const unixNow = Math.floor(
      new Date(Math.floor(Date.now() / cacheLifetime) * cacheLifetime).getTime() / 1000,
    );
    return {
      variables: {
        timestampRange: {
          since: unixNow - locale.graphPeriodUnix,
          until: unixNow,
        },
      },
    };
  },
})(TopSection);



// WEBPACK FOOTER //
// /www/client/src/containers/HomePage/TopSection/TopSection.tsx